import React from "react";
import RptPtosPanorama from "../RptPtosPanorama";
import RptPtosConfig from "../RptPtosConfig";
import RptDispositivos from "../RptDispositivos";
import RptHistoricosDispositivos from "../RptHistoricosDispositivos";
import { useAppSelector } from "../../../hooks/useAppSelector";
import "./styles.scss";

import { BarChart3, Settings, Cpu, History, Store } from "lucide-react";

const REPORT_OPTIONS = [
  {
    key: "RptPtosPanorama",
    label: "Panorama dos Pontos",
    description:
      "Visão geral do status de todos os pontos monitorados da loja.",
    Icon: BarChart3,
    Component: RptPtosPanorama,
  },
  {
    key: "RptPtosConfig",
    label: "Configuração dos Pontos",
    description: "Como cada ponto de monitoramento está configurado hoje.",
    Icon: Settings,
    Component: RptPtosConfig,
  },
  {
    key: "RptDispositivos",
    label: "Dispositivos",
    description: "Lista dos equipamentos instalados e seus dados técnicos.",
    Icon: Cpu,
    Component: RptDispositivos,
  },
  {
    key: "RptHistoricosDispositivos",
    label: "Histórico de Dispositivos",
    description: "Linha do tempo de eventos e trocas de cada dispositivo.",
    Icon: History,
    Component: RptHistoricosDispositivos,
  },
];

const SelectTypeReport = () => {
  const [selected, setSelected] = React.useState<string>("");

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const lojas = useAppSelector((state) => state.getLojas.lojas);

  if (!lojaSelected) {
    return (
      <div className="report-empty-state">
        <Store />
        <strong>Selecione uma loja para começar</strong>
        <span>
          Use o seletor de loja acima para ver os relatórios disponíveis.
        </span>
      </div>
    );
  }

  const lojaNome = lojas.find((loja) => loja.id === Number(lojaSelected))?.nome;
  const ActiveComponent = REPORT_OPTIONS.find(
    (opt) => opt.key === selected,
  )?.Component;

  return (
    <div className="report-by-loja">
      {lojaNome && (
        <div className="report-by-loja__loja">
          <Store />
          <strong>{lojaNome}</strong>
        </div>
      )}

      <p className="report-by-loja__hint">
        Escolha o tipo de relatório que você quer visualizar:
      </p>

      <div className="report-type-grid">
        {REPORT_OPTIONS.map((opt) => (
          <button
            key={opt.key}
            type="button"
            className={`report-type-card ${selected === opt.key ? "is-active" : ""}`}
            onClick={() => setSelected(opt.key)}
          >
            <opt.Icon className="report-type-card__icon" size={24} />
            <span className="report-type-card__label">{opt.label}</span>
            <span className="report-type-card__description">
              {opt.description}
            </span>
          </button>
        ))}
      </div>

      {ActiveComponent && (
        <div className="report-by-loja__content">
          <ActiveComponent />
        </div>
      )}
    </div>
  );
};

export default SelectTypeReport;
